import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDisableVerifiedBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.disableVerifiedBadge,
  {
    mutationKey: ['disableVerifiedBadge'],
  },
)
